var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoltSolid = function SvgBoltSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.5 5.999 2.168.656A.75.75 0 0 1 2.913 0h3.952a.634.634 0 0 1 .595.858L6.375 3.749H9.64a.86.86 0 0 1 .71 1.345L5.845 11.68a.74.74 0 0 1-.607.321H5.17a.67.67 0 0 1-.647-.83L5.625 6.75H2.25a.75.75 0 0 1-.75-.75"
  })));
};
export default SvgBoltSolid;